import { Component } from '@angular/core';
import module from 'app/modules/management-of-change/moc.module';
import { Router } from '@angular/router';

@Component({
  selector: 'app-index',
  templateUrl: './index.page.html',
  imports: module,
  standalone: true,
  styleUrls: ['./index.page.scss']
})
export class MocIndexPage {

  constructor(
    public router: Router,
  ){ }

  toggleMawop(routes: any){
    this.router.navigate([`/data-management/management-of-change/${routes}`]);
  }
}


